import React from "react";
import { withStableUniqueId } from "react-stable-uniqueid";

import styles from "./Pirate.css";

import BoyHead from "./parts/BoyHead";

import Scarf1 from "./accessories/head/Scarf1";
/*
import GirlHead from "./parts/GirlHead";

import Vest1 from "./accessories/body/Vest1";
import Coat1 from "./accessories/body/Coat1";
import Sword1 from "./accessories/leftHand/Sword1";
import Hook1 from "./accessories/rightHand/Hook1";
import Hat1 from "./accessories/head/Hat1";
import Hat2 from "./accessories/head/Hat2";
import EyePatch1 from "./accessories/head/EyePatch1";
import Boots1 from "./accessories/feet/Boots1";
import Belt1 from "./accessories/body/Belt1";
import Trousers1 from "./accessories/legs/Trousers1";
import Sword2 from "./accessories/leftHand/Sword2";
import Boots2 from "./accessories/feet/Boots2";
import Pistol1 from "./accessories/rightHand/Pistol1";
import EyePatch2 from "./accessories/head/EyePatch2";
import Parrot1 from "./accessories/rightHand/Parrot1";
*/

const Pirate = ({ uniqueId }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 478.88 567.36"
    preserveAspectRatio="xMidYMax"
    className={styles.pirate}
  >
    <defs>
      <clipPath id={`${uniqueId}-clip-path`}>
        <path
          d="M215.55,345s-75.86,16.05-86.1,10.94c0,0-5.36,16,.89,25,2.4,3.44,53.57,7.89,68.92,2.78C199.27,383.68,218.75,353.27,215.55,345Z"
          fill="none"
        />
      </clipPath>
      <clipPath id={`${uniqueId}-clip-path-2`}>
        <path
          d="M270,345S345.82,361,356,355.89c0,0,5.36,16-.89,25-2.4,3.44-53.57,7.89-68.92,2.78C286.24,383.68,266.76,353.27,270,345Z"
          fill="none"
        />
      </clipPath>
      <clipPath id={`${uniqueId}-clip-path-3`}>
        <path
          d="M268.09,341.16,250,340.63l-.05-.42-7.15.21-7.15-.21-.05.42-18.07.53s-29.56,37.19-26.7,97.27c0,0,9.8,11.68,52,12.12,42.12-.44,52-12.12,52-12.12C297.66,378.35,268.09,341.16,268.09,341.16Z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="Right Arm">
      <path
        d="M129.48,357s-17.92-12.85-22-9.59c-5.38,4.3,5,9.46,5,9.46s-20.92-6.5-19.73.29c.75,4.32,12.73,5.36,12.73,5.36s-17.15-.67-15.28,5.18c1.8,5.66,15.45,3.23,15.45,3.23s-14.94,2.47-13.28,7.17c1.76,5,14.79.13,14.79.13s-10.49,3.92-8,8.71c1.24,2.35,10.3.78,18.07-2.58,0,0,12.24-5.09,13.69-6.79C136.94,370.53,132.5,357.9,129.48,357Z"
        fill="#fdd0b3"
      />

      <g>
        <path
          d="M215.79,344.93s-76.1,16.08-86.33,11c0,0-5.36,16,.89,25,2.4,3.44,53.57,7.89,68.92,2.78C199.27,383.68,219,353.24,215.79,344.93Z"
          fill="#e2e2e2"
        />

        <g clipPath={`url(#${uniqueId}-clip-path)`}>
          <path
            d="M174.94,348.87s7.83,24.47,1.17,43.84c0,0,18.75.54,21.53-2.94s2.94-41.3-3.24-43.7C191.22,344.85,174.94,348.87,174.94,348.87Z"
            fill="#cb0000"
          />
          <path
            d="M143.23,353.57s3.91,24.47-1,36.37c0,0,12.59,2.12,18.86,0,0,0,3.72-22.31-1.57-39Z"
            fill="#cb0000"
          />
        </g>
      </g>
    </g>
    <g data-name="Left Arm">
      <path
        d="M356,357s17.92-12.85,22-9.59c5.38,4.3-5,9.46-5,9.46s20.92-6.5,19.73.29c-.75,4.32-12.73,5.36-12.73,5.36s17.15-.67,15.28,5.18c-1.8,5.66-15.45,3.23-15.45,3.23s14.94,2.47,13.28,7.17c-1.76,5-14.79.13-14.79.13s10.49,3.92,8,8.71c-1.24,2.35-10.3.78-18.07-2.58,0,0-12.24-5.09-13.69-6.79C348.57,370.53,353,357.9,356,357Z"
        fill="#fdd0b3"
      />

      <g>
        <path
          d="M269.72,344.93s76.1,16.08,86.33,11c0,0,5.36,16-.89,25-2.4,3.44-53.57,7.89-68.92,2.78C286.24,383.68,266.52,353.24,269.72,344.93Z"
          fill="#e2e2e2"
        />

        <g clipPath={`url(#${uniqueId}-clip-path-2)`}>
          <path
            d="M310.57,348.87s-7.83,24.47-1.17,43.84c0,0-18.75.54-21.53-2.94s-2.94-41.3,3.24-43.7C294.29,344.85,310.57,348.87,310.57,348.87Z"
            fill="#cb0000"
          />
          <path
            d="M342.28,353.57s-3.91,24.47,1,36.37c0,0-12.59,2.12-18.86,0,0,0-3.72-22.31,1.57-39Z"
            fill="#cb0000"
          />
        </g>
      </g>
    </g>
    <g data-name="Hip">
      <path
        d="M282.82,470.38c-6,6.15-18,14-39.21,14s-34.4-8.24-41-13.75c-7.27-6.09-15.18-19.9-12-24.92,4.66-7.42,41.91-4,52.34-4,13.27,0,45.38-4.27,52.48,3.25C299.68,449.54,288.18,464.86,282.82,470.38Z"
        fill="#475369"
      />
    </g>
    <g data-name="Left Leg">
      <path
        d="M282.06,527.72s20.73,4.52,23.5,9.5c2.08,3.73,1.5,7-7.5,8.5-4.63.77-16.25-.65-26.51-2-9.68-1.28-18.23-2.28-15.81-8.16,3.21-7.81,2.4-10.77,4.26-16,1.29-3.62,16.66-4.44,21.82-2.52C284.52,518.08,282.06,527.72,282.06,527.72Z"
        fill="#fdd0b3"
      />
      <path
        d="M256.2,525.93s.63-55.13-10.09-68.71c0,0,38.68-34.14,48.61-19.73,0,0,6.48,50.94-8.52,88.94a36.91,36.91,0,0,1-2.17-4s-1.8,4.27-3.91,5.77a21.43,21.43,0,0,1-1.68-4.33s-3.49,4.33-5,5.05c0,0-2.89-6.49-2.77-7.88,0,0-3.31,6.07-5.11,7.15,0,0-2.77-5.11-2.58-7.33C263,520.86,258,525.59,256.2,525.93Z"
        fill="#475369"
      />
    </g>
    <g data-name="Right Leg">
      <path
        d="M203.94,527.72s-20.73,4.52-23.5,9.5c-2.08,3.73-1.5,7,7.5,8.5,4.63.77,16.25-.65,26.51-2,9.68-1.28,18.23-2.28,15.81-8.16-3.21-7.81-2.4-10.77-4.26-16-1.29-3.62-16.66-4.44-21.82-2.52C201.47,518.08,203.94,527.72,203.94,527.72Z"
        fill="#fdd0b3"
      />
      <path
        d="M229.79,525.93s-.63-55.13,10.09-68.71c0,0-38.86-33.65-48.79-19.24,0,0-6.3,50.46,8.7,88.46a36.82,36.82,0,0,0,2.17-4s1.8,4.27,3.91,5.77a21.5,21.5,0,0,0,1.68-4.33s3.49,4.33,5,5.05c0,0,2.89-6.49,2.77-7.88,0,0,3.31,6.07,5.11,7.15,0,0,2.77-5.11,2.58-7.33C223,520.86,228,525.59,229.79,525.93Z"
        fill="#475369"
      />
    </g>
    <g data-name="Body">
      <path
        d="M268.09,341.16,250,340.63l-.05-.42-7.15.21-7.15-.21-.05.42-18.07.53s-29.56,37.19-26.7,97.27c0,0,9.8,11.68,52,12.12,42.12-.44,52-12.12,52-12.12C297.66,378.35,268.09,341.16,268.09,341.16Z"
        fill="#e2e2e2"
      />
      <ellipse cx="242.82" cy="347.14" rx="15.67" ry="10.33" fill="#e5a37f" />
      <g clipPath={`url(#${uniqueId}-clip-path-3)`}>
        <path
          d="M181.68,417s41.15,30.18,127.11,0l-4.57-17.37s-64,21.95-122.54-.92Z"
          fill="#cb0000"
        />
        <path
          d="M181.39,373.37s41.33,28.48,119.57,2.89l-4.07-18.32s-57,20-115.5-2.85Z"
          fill="#cb0000"
        />
      </g>
    </g>
    <g data-name="Feet accessories" />
    <g data-name="Body accessories" />
    <BoyHead />
    <g data-name="Right hand accessories" />
    <g data-name="Left hand accessories" />
    <g data-name="Head accessories">
      <Scarf1 />
    </g>
  </svg>
);

export default withStableUniqueId()(Pirate);



// WEBPACK FOOTER //
// ./src/components/Pirate/Pirate.js